<template>
	<vx-card title="المواضيع">
		<div id="div-with-loading" class="vs-con-loading__container">
			<vs-table max-items="3" search :data="data">
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" >
					<div class="flex flex-wrap-reverse items-center data-list-btn-container">
						<!-- ADD NEW -->
						<div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" >
							<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 text-base text-primary" @click="addNewItem" >إضافة</span >
						</div>
					</div>
				</div>

				<template slot="thead">
					<vs-th>الاسم</vs-th>
					<vs-th>العمليات</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td :data="data[indextr].id">
							{{ data[indextr].name }}
						</vs-td>
						
						<vs-td :data="data[indextr].id" id="action">
							<vs-td class="whitespace-no-wrap">
								<feather-icon
									icon="EditIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="editData(indextr)"
								/>
								<feather-icon
									icon="TrashIcon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="openConfirm(indextr)"
								/>
							</vs-td>
							<!-- {{data[indextr].id}} -->
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
		<vs-pagination :total="totalPages" v-model="currentPage" />
		<add-edit-form
			ref="addEditForm"
			:promptStatus="activePrompt"
			:oldDataObject="oldDataObject"
			@updateStatus="updateStatus($event)"
			@close="closeModel"
		>
		</add-edit-form>


		<vs-prompt
		@cancel="close"
		@accept="deleteRequest"
		@close="close"
		accept-text="تأكيد الحذف"
		cancel-text="الغاء"
		title="تأكيد الحذف"
		color='danger'
		:active.sync="deletePrompt">
				<div class="con-exemple-prompt">
					<h3>هل أنت متأكد من حذف هذه التسجيلة</h3>
      			</div>
    	</vs-prompt>
	</vx-card>
</template>

<script>
import axios from "axios";
import addEditForm from "./form";
const initObject = {
	id: -1,
	name: '',
};
export default {
	components: { addEditForm },
	data() {
		return {
			deleteItemId: -1,
			deletePrompt: false,
			activePrompt: false,
			data: [],
			oldDataObject: {...initObject},
			page: 1,
			totalPages: 1
		};
	},
	methods: {
		addNewItem(){
		    this.oldDataObject = {...initObject};
			this.activePrompt = true;
		},
		editData(idx){
			this.oldDataObject = Object.assign({} , this.data[idx]);
			this.activePrompt = true;
		},
		openConfirm(id){
			this.deleteItemId = id;
			this.deletePrompt = true;
		},
		updateStatus(event) {
			if(event.isNew === true){
				  this.data.push(event.data);
			}else{
				let roleIdx = this.data.findIndex(e => e.id === event.data.id);
				this.$set(this.data, roleIdx, event.data);
			}
			this.activePrompt = false;
		},
		closeModel(){
			this.activePrompt = false;
		},
		close() {
			this.deletePrompt = false;
		},
		getData(page) {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6
			});
			axios.get("/topic?page=" + page + '&pagination=1').then(response => {
				this.data = response.data.data.data;
				this.totalPages = response.data.data.last_page;
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			});
		},
		deleteRequest(){
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6
			});
			axios.delete('/topic/' + this.data[this.deleteItemId].id)
			.then(res => {
				if(res.status === 200){
					this.data.splice(this.deleteItemId, 1);
					this.$vs.notify({
							title: "تم الحذف بنجاح",
							text: "تم حذف التسجيلة بنجاح",
							color: "success",
							position: "top-left"
						});
				}
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			}).catch(e => {
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			});
		},

	},
	mounted() {
		this.getData(this.page);
	},
	computed: {
		currentPage: {
			get() {
				return this.page;
			},
			set(val) {
				this.page = val;
				this.getData(this.page);
			}
		}
	}
};
</script>

<style scoped>
#action {
	margin-left: 200px;
}
</style>
